export default "__VITE_ASSET__f56906c6__"